import React from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from 'oidc-react'
import SignIn from './SignIn.js'

function AddIdentity() {
  const { userData } = useAuth()
  const params = new URLSearchParams(useLocation().search)
  const providerHint =
    params.get('id_type') ||
    params.get('provider_hint') ||
    params.get('provider')

  if (userData?.access_token) {
    localStorage.setItem('addIdentityToken', userData.access_token)
    localStorage.setItem('isAddIdentity', 'true')
  }

  return userData?.access_token ? (
    <SignIn
      screenHint="signup"
      providerHint={providerHint}
      isAddIdentity={true}
    />
  ) : (
    <div>
      <p>Checking credentials to add identity assignment...</p>
    </div>
  )
}

export default AddIdentity
